/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { MapTo, EditableComponent, Container } from '@adobe/aem-react-editable-components';

type IntrinsicTag = keyof JSX.IntrinsicElements;

export interface SectionProps {
  tagName?: IntrinsicTag;
  cssClass?: string;
  gridClassNames?: string;
  cqPath?: string;
  className?: string;
  [key: string]: any;
}

export const Section: React.FC<SectionProps> = props => {
  /* eslint-disable @typescript-eslint/no-unused-vars */
  const { gridClassNames, className = 'container', cqPath, isInEditor, ...rest } = props;
  const { model } = rest;
  const { tagName = 'section', cssClass = '' } = model ?? {};

  const Tag = tagName as IntrinsicTag;

  const mergedClassName = ['lt-section', cssClass || gridClassNames, className].filter(Boolean).join(' ').trim();

  const editConfig = {
    emptyLabel: 'Section',
    isEmpty: () => true,
  };

  return (
    <EditableComponent {...props} config={editConfig}>
      <Tag className={mergedClassName}>
        <Container {...rest} cqPath={cqPath} className={`container`} />
      </Tag>
    </EditableComponent>
  );
};
